<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        setTimeout(async function(){
            
                let respManufacturers = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type:"TRUCK_TRAILER"}, `${Endpoints.parts.manufacturer.listByType}`)).data;
                if (respManufacturers.status==200){
                    payload.manufacturers = respManufacturers.results;
                 }
            
        }, 100);
        
    },
    methods:{
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            
            if(copy.actualKM){
                copy.actualKM = Number(copy.actualKM)
            }

            if(copy.manufacturer && copy.manufacturer._id){
                copy.manufacturer = copy.manufacturer._id;
            }

            if(copy.truckDriver && copy.truckDriver._id){
                copy.truckDriver = copy.truckDriver._id;
            }
            
            copy.oldDocumentPhotoURL = copy.documentPhotoURL;
            this.$emit('load-item', copy);
        },
        filter: function(){
            $('#spinner').modal('toggle');
            if(this.filters.manufacturer ==-1){
                this.titleToast = this.$t('string.msg.warning');
                this.messageToast = this.$t('string.msg.filter.select.required');
                $('#toast').modal('show');
            }
            else{
                let payload = this;
                payload.items = [];
                setTimeout(async function(){
                    let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
                    let truckTrailer = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), 
                    payload.filters, 
                    `${Endpoints.trucks.listByType}`));
                    if (truckTrailer.status==200){
                        payload.items = truckTrailer.data.results;
                    }
                    $('#spinner').modal('toggle');
                }, 100);
            }
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
        fetchData(){
            // console.log(this.items.companyUser.company);
            this.json_data = this.items;
            return this.json_data;
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
